import { render, staticRenderFns } from "./audioSlider.vue?vue&type=template&id=c8b5d508&scoped=true"
import script from "./audioSlider.vue?vue&type=script&lang=js"
export * from "./audioSlider.vue?vue&type=script&lang=js"
import style0 from "./audioSlider.vue?vue&type=style&index=0&id=c8b5d508&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b5d508",
  null
  
)

export default component.exports